import type { ComponentType, CSSProperties } from "react";
import QueryErrorBoundary from "./QueryErrorBoundary";

export function withQueryErrorResetBoundary<P extends {}>(
  WrappedComponent: ComponentType<P>,
  boundaryProps?: {
    errorStyle?: CSSProperties;
  },
): React.FC<P> {
  const ComponentWithBoundary: React.FC<P> = (props) => {
    return (
      <QueryErrorBoundary errorStyle={boundaryProps?.errorStyle}>
        <WrappedComponent {...(props as P)} />
      </QueryErrorBoundary>
    );
  };

  ComponentWithBoundary.displayName = `withQueryErrorResetBoundary(${
    WrappedComponent.displayName || WrappedComponent.name || "Component"
  })`;

  return ComponentWithBoundary;
}
